import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { reFormatDate } from "../../../../utils/utils";
import { groupTransactions } from "../../../../comps/Accounts/BackEnd/AccountingRPT/accountingRPTTableItems";
import SubRowsAccounts from "./SubRows";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));


export default function BodyItems(props) {
    const { data
    } = props;
    const stylRo = {
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{
                width: "100%",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                overflow: "hidden",
                direction: "rtl",
                backgroundColor: "#fff",

                "@media print": {
                    border: "1px solid #999",
                    borderRadius: 0,
                    boxShadow: "none",
                    overflow: "visible",
                },
            }}
        >
            <Table
                size="small"
                sx={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",

                    "& th": {
                        backgroundColor: "#f3f4f6",
                        color: "#222",
                        fontWeight: 700,
                        fontSize: "11px",
                        padding: "7px 6px",
                        borderBottom: "1.5px solid #777",
                        borderLeft: "1px solid #ddd",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                    },

                    "& td": {
                        fontSize: "10.5px",
                        color: "#222",
                        padding: "6px",
                        borderBottom: "1px solid #e2e2e2",
                        borderLeft: "1px solid #e5e5e5",
                        verticalAlign: "middle",
                    },

                    "& tbody tr:hover": {
                        backgroundColor: "#fafafa",
                    },

                    "& tbody tr:last-child td": {
                        borderBottom: "1px solid #999",
                    },

                    "@media print": {
                        "& th": {
                            backgroundColor: "#f1f1f1 !important",
                            WebkitPrintColorAdjust: "exact",
                            printColorAdjust: "exact",
                            fontSize: "9.5px",
                            padding: "5px 4px",
                            borderBottom: "1px solid #555",
                        },

                        "& td": {
                            fontSize: "9px",
                            padding: "4px",
                            borderBottom: "1px solid #ccc",
                        },

                        "& tbody tr": {
                            pageBreakInside: "avoid",
                            breakInside: "avoid",
                        },
                    },
                }}
            >

                {/* ================= HEADER ================= */}

                <TableHead>
                    <TableRow>

                        <TableCell style={{backgroundColor:colors.grey[300],fontWeight:"bold"}}
                            sx={{
                                width: "25%",
                            }}
                        >
                            {t("note")}{" "}
                        </TableCell>
                        <TableCell style={{backgroundColor:colors.grey[300],fontWeight:"bold"}}
                            sx={{
                                width: "15%",
                                textAlign: "right !important",
                            }}
                        >
                            {t("date")}{" "}
                        </TableCell>
                        <TableCell style={{backgroundColor:colors.grey[300],fontWeight:"bold"}}
                            sx={{
                                width: "15%",
                            }}
                        >
                            {"رقم المستند"}
                        </TableCell>

                        <TableCell style={{backgroundColor:colors.grey[300],fontWeight:"bold"}}
                            sx={{
                                width: "15%",
                            }}
                        >
                            {t("dept")}
                        </TableCell>
                        <TableCell style={{backgroundColor:colors.grey[300],fontWeight:"bold"}}
                            sx={{
                                width: "15%",
                            }}
                        >
                            {t("credit")}{" "}
                        </TableCell>

                        <TableCell style={{backgroundColor:colors.grey[300],fontWeight:"bold"}}
                            sx={{
                                width: "15%",
                            }}
                        >
                            {t("balance")}
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>

                    {/* مثال سجل */}
                    {data.map((row, i) => (
                        <>
                            <TableRow>

                                <TableCell align="center" style={{fontWeight:"bold"}}>
                                    {row.notes}
                                </TableCell>

                                <TableCell style={{fontWeight:"bold"}}>
                                    {row?.doc_no}
                                </TableCell>

                                <TableCell align="center" style={{fontWeight:"bold"}}>
                                    {row.date != null ? reFormatDate(row?.date) : ""}
                                </TableCell>

                                <TableCell style={{fontWeight:"bold"}}>
                                    {row.dept.toFixed(2)}
                                </TableCell>

                                <TableCell align="left" style={{fontWeight:"bold"}}>
                                    {row.credit.toFixed(2)}
                                </TableCell>

                                <TableCell align="left" style={{fontWeight:"bold"}}>
                                    {row.Balance?.toFixed(2)}
                                </TableCell>
                            </TableRow>


                            {/* ================= تفاصيل الأصناف ================= */}
                            <SubRowsAccounts row={row} />
                        </>
                    ))}

                </TableBody>


                {/* ================= FOOTER ================= */}
                {/* 
                <TableFooter>

                    <TableRow>

                        <TableCell
                            colSpan={4}
                            sx={{
                                fontWeight: 700,
                                fontSize: "11px",
                                borderTop: "1.5px solid #555",
                                backgroundColor: "#f5f5f5",
                            }}
                        >
                            الرصيد النهائي
                        </TableCell>

                        <TableCell
                            colSpan={3}
                            align="left"
                            sx={{
                                fontWeight: 700,
                                fontSize: "11px",
                                borderTop: "1.5px solid #555",
                                backgroundColor: "#f5f5f5",
                            }}
                        >
                            5,200.00
                        </TableCell>

                    </TableRow>

                </TableFooter> */}

            </Table>
        </TableContainer>
    );
}
